/** Overall skin score gauge — matches SkinRoutinePage canvas drawing. */
export function drawSkinGauge(canvas, overallSkinScore) {
  if (!canvas || overallSkinScore == null) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  const cx = canvas.width / 2;
  const cy = 210;
  const radius = 120;
  const thickness = 30;

  const scoreMap = {
    critical: { color: '#ff4757', label: 'Critical' },
    poor: { color: '#ffa502', label: 'Poor' },
    fair: { color: '#eccc68', label: 'Fair' },
    good: { color: '#7bed9f', label: 'Good' },
    excellent: { color: '#2ed573', label: 'Great' },
  };

  const segments = [
    { start: 0.90, end: 1.13, key: 'critical' },
    { start: 1.15, end: 1.37, key: 'poor' },
    { start: 1.39, end: 1.61, key: 'fair' },
    { start: 1.63, end: 1.85, key: 'good' },
    { start: 1.87, end: 2.10, key: 'excellent' },
  ];

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  segments.forEach((seg) => {
    const config = scoreMap[seg.key];

    ctx.beginPath();
    ctx.arc(cx, cy, radius, seg.start * Math.PI, seg.end * Math.PI);
    ctx.strokeStyle = config.color;
    ctx.lineWidth = thickness;
    ctx.lineCap = 'butt';
    ctx.stroke();

    const midAngle = ((seg.start + seg.end) / 2) * Math.PI;
    const tx = cx + (radius + 35) * Math.cos(midAngle);
    const ty = cy + (radius + 35) * Math.sin(midAngle);

    ctx.save();
    ctx.translate(tx, ty);
    ctx.rotate(midAngle + Math.PI / 2);
    ctx.fillStyle = '#636e72';
    ctx.font = '600 11px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(config.label.toUpperCase(), 0, 0);
    ctx.restore();
  });

  const startRad = 0.9;
  const endRad = 2.1;
  const needleRad = (startRad + (overallSkinScore / 100) * (endRad - startRad)) * Math.PI;

  ctx.save();
  ctx.translate(cx, cy);
  ctx.rotate(needleRad);
  ctx.shadowBlur = 10;
  ctx.shadowColor = 'rgba(0,0,0,0.1)';

  ctx.beginPath();
  ctx.moveTo(0, -4);
  ctx.lineTo(radius - 5, 0);
  ctx.lineTo(0, 4);
  ctx.fillStyle = '#2d3436';
  ctx.fill();

  ctx.beginPath();
  ctx.arc(0, 0, 10, 0, Math.PI * 2);
  ctx.fillStyle = '#ffffff';
  ctx.fill();
  ctx.lineWidth = 3;
  ctx.strokeStyle = '#2d3436';
  ctx.stroke();
  ctx.restore();
}
